import styled, {css} from "styled-components";
import {Link} from 'react-router-dom';
import {UilTimes} from '@iconscout/react-unicons';
import {Grid, Container,} from '../ReUsableStyles';
import { Link as LinkScroll } from "react-scroll";
import LogoFont from '../fonts/Bacalisties-2OnXo.ttf';


const LogoToggle = css`
    color: var(--title-color);
    font-weight: var(--font-medium);
`;


export const Header = styled.header`
    width: 100%;
    position: fixed;
    bottom:0;
    left:0;
    z-index: var(--z-fixed);
    background-color: var(--body-color);
    ${props=>props.isScrolled && css`box-shadow: 0 -1px 4px rgba(0,0,0,.15);`}
`;

export const Nav = styled.nav`
    ${Container};
    max-width: 968px;
    height: var(--header-height);
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const NavLogo = styled(Link)`
    @font-face{
        font-family: "Logo";
        src: url(${LogoFont});
        
    }
    color: var(--first-color);
    font-family:"Logo"; 
    font-weight: var(--font-medium);
    font-size:2.5rem;
    ${LogoToggle};
    // &:hover{
    //     color: var(--first-color);
    // }
`;

export const NavMenu = styled.div`
    @media screen and (max-width: 767px){
            position: fixed;
            bottom:${(props)=>props.open? '0': '-100%'};
            left: 0;
            width: 100%;
            background-color: var(--body-color);
            padding: 2rem 1.5rem 4rem;
            box-shadow: 0 -1px 4px rgba(0,0,0, .15);
            border-radius: 1.5rem 1.5rem 0 0 ;
            transition: .3s;
    }
`;
export const NavList = styled.ul`
    ${Grid};
    grid-template-columns: repeat(3,1fr);
    gap:2rem;
`;
export const NavItem = styled.li`
    
`;
export const NavLink = styled(LinkScroll)`
    display: flex;
    flex-direction:column;
    align-items:center;
    font-size: var(--small-font-size);
    color: var(--title-color);
    font-weight: var(--font-medium);
    &:hover{
        color:var(--first-color);
        cursor:pointer;
    }

    .nav-icon{
        font-size: 1.2rem;
    }
    &.active{
        color:var(--first-color);
    }
`;

export const NavBtns = styled.div`
    display:flex;
    align-items:center;

    .change-theme{
        color:var(--title-color);
        margin-right: var(--mb-1);
        cursor:pointer;
        :hover{
            color:var(--first-color);
        }
    }
`;

export const Navclose = styled(UilTimes)`
    position: absolute;
    right:1.3rem;
    bottom: .5rem;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--first-color);

    &:hover{
        color: var(--first-color-alt);
    }
`;

export const NavToggle = styled.div`
    ${LogoToggle};
    &:hover{
        color: var(--first-color);
        cursor:pointer;
    }
`;

export const Main = styled.main`

`;

//scroll page to the top 
export const Scrollup = styled(Link)`
    position:fixed;
    right:1rem;
    bottom:${props=>props.scrolled? '5rem': '-20%'};
    display:flex;
    background-color:var(--first-color);
    border-radius:.4rem;
    padding:  .3rem;
    opacity:.8;
    z-index:  var(--z-tooltip);
    transition:.4s;

    .scroll__icon{
        color: #fff;
        font-size: 1.5rem;
    }

    &:hover{
        background-color:var(--first-color-alt);
        // opacity:1;
    }
`;